export default __webpack_public_path__ + "static/media/pin-location-green.c411d6d5.svg";